import {ServiceBase} from "../ServiceBase";
import {IInGameChallengeService} from "./in-game-challenge.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IFirebaseTopicRegistration} from "../firebase/topics/firebase-topic-view-model.interface";
import {IInGameCampaign} from "../firebase/topics/in-game-challenges/add-to-campaign/add-to-campaign-topic.model.interface";
import {IIGCLiveProgressUpdateData} from "../firebase/topics/in-game-challenges/live-progress-update/live-progress-update-topic.model.interface";

export class InGameChallengeService extends ServiceBase implements IInGameChallengeService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.reaction(() => this.services.user.isAuthorized,
            (isAuth) => {
                this.dispose();
                if (isAuth) {
                    this._firebaseRegistrations.push(services.firebase.topics.igcAddToCampaign.registerListener(this._handleCampaignsUpdate.bind(this)));
                }
            }, {
            fireImmediately: true
        });
    }

    private _firebaseRegistrations: IFirebaseTopicRegistration[] = [];

    _handleCampaignsUpdate(campaigns: IInGameCampaign[]) {
        for (let i = 0; i < campaigns.length; i++) {
            const currentCampaign = campaigns[i];
            if (new Date(currentCampaign.CampaignExpirationDate) > new Date()) {
                this.services.logger.debug(`InGame Challenge: Campaign ${currentCampaign.CampaignId} is active, Orbit will register for live progress updates`);
                this._firebaseRegistrations.push(this.services.firebase.topics.igcLiveProgress.registerListener(this.onLiveProgressUpdate.bind(this)));
                break;
            }
        }
    }

    onLiveProgressUpdate(progressUpdate: IIGCLiveProgressUpdateData) {
        this.services.logger.debug(`InGame Challenge: recived live progress update for campaign ${progressUpdate.CampaignId}: ${progressUpdate}`);
    }

    dispose(): void {
        this._firebaseRegistrations.forEach(r => r.unregister());
        this._firebaseRegistrations = [];
    }
}